var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_product_code"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "productCode"
                          }
                        },
                        [
                          _c("a-input-search", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["gift_product_code"],
                              maxLength: 30,
                              disabled: _vm.productCodeDisable
                            },
                            on: {
                              keydown: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.onSearch($event)
                              },
                              search: _vm.onSearch
                            },
                            model: {
                              value: _vm.model.productCode,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "productCode", $$v)
                              },
                              expression: "model.productCode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_product_name"],
                            labelCol: _vm.labelCol3,
                            wrapperCol: _vm.wrapperCol2,
                            prop: "name"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "", disabled: "" },
                            model: {
                              value: _vm.model.productName,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "productName", $$v)
                              },
                              expression: "model.productName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_user_app"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "app"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.model.appName,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "appName", $$v)
                              },
                              expression: "model.appName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_product_vendor"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "supplier"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.model.supplierName,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "supplierName", $$v)
                              },
                              expression: "model.supplierName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_product_price"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "price"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["gift_product_price"],
                              disabled: ""
                            },
                            model: {
                              value: _vm.model.price,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "price", $$v)
                              },
                              expression: "model.price"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_product_limit"],
                            labelCol: _vm.labelCol
                          }
                        },
                        [
                          _c("a-switch", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.model.limited > 0,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "limited > 0", $$v)
                              },
                              expression: "model.limited > 0"
                            }
                          }),
                          _c("a-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.model.limited > 0,
                                expression: "model.limited > 0 "
                              }
                            ],
                            staticStyle: {
                              width: "57%",
                              "margin-left": "10px"
                            },
                            attrs: { disabled: _vm.disabled, disabled: "" },
                            model: {
                              value: _vm.model.limited,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "limited", $$v)
                              },
                              expression: "model.limited "
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          staticStyle: { "margin-left": "20px" },
                          attrs: {
                            label: _vm.language["gift_app_up_down"],
                            labelCol: _vm.labelCol2,
                            wrapperCol: _vm.wrapperCol
                          }
                        },
                        [
                          _c("a-switch", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.model.status === 1,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "status === 1", $$v)
                              },
                              expression: "model.status === 1"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_product_virtual"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "virtual"
                          }
                        },
                        [
                          _c("a-switch", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.model.virtual === 1,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "virtual === 1", $$v)
                              },
                              expression: "model.virtual === 1"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "a-tabs",
        {
          on: { change: _vm.handleChangeTabs },
          model: {
            value: _vm.activeKey,
            callback: function($$v) {
              _vm.activeKey = $$v
            },
            expression: "activeKey"
          }
        },
        [
          _c(
            "a-tab-pane",
            {
              key: _vm.refKeys[0],
              attrs: {
                tab: "*" + _vm.language["gift_product_stock"],
                forceRender: true
              }
            },
            [
              _c("j-editable-table", {
                ref: _vm.refKeys[0],
                attrs: {
                  loading: _vm.productStockTable.loading,
                  columns: _vm.productStockTable.columns,
                  dataSource: _vm.productStockTable.dataSource,
                  maxHeight: 300,
                  rowNumber: true,
                  disabled: _vm.formDisabled,
                  rowSelection: false,
                  actionButton: false
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }